import { Dispatch, FC, SetStateAction } from 'react'

/* Utils */
import { useLibraryDetails } from 'contexts/LibraryDetailsContext'
import {
  ColumnValue,
  CompetitorAnalysisData,
  DetailedComparisonData,
  DevicesQueryPagination,
  DevicesQueryPayload
} from 'models'

/* Components */
import { TrendsTabPanel } from './tabs/TrendsTabPanel'
import { DevicesTabPanel } from './tabs/DevicesTabPanel'
import { AboutTabPanel } from './tabs/AboutTabPanel'
import { BenchmarkingTabPanel } from './tabs/BenchmarkingTabPanel'

interface TabPanelsProps {
  columnValues: ColumnValue[]
  setColumnValues: Dispatch<SetStateAction<ColumnValue[]>>
  getLookup: (columnId: string) => Promise<string[]>
  devicesPagination: DevicesQueryPagination
  thisCpiName: string
  fetchQuery: ({ page, payload }: { page?: number; payload?: DevicesQueryPayload }) => Promise<any>
  customerName: string
  competitorAnalysisData: CompetitorAnalysisData | null
  detailedComparisonData: DetailedComparisonData | null
  setColumnsFetched: (value: boolean) => void
}

const TabPanels: FC<TabPanelsProps> = ({
  columnValues,
  setColumnValues,
  getLookup,
  devicesPagination,
  thisCpiName,
  fetchQuery,
  customerName,
  competitorAnalysisData,
  detailedComparisonData,
  setColumnsFetched
}) => {
  const { active, snowflakeManifest, showBenchmarkingTab, initialLoad } = useLibraryDetails()

  return (
    <>
      {active && <TrendsTabPanel />}

      {active && snowflakeManifest && (
        <DevicesTabPanel
          columnValues={columnValues}
          setColumnValues={setColumnValues}
          getLookup={getLookup}
          devicesPagination={devicesPagination}
          thisCpiName={thisCpiName}
          fetchQuery={fetchQuery}
          customerName={customerName}
          setColumnsFetched={setColumnsFetched}
        />
      )}

      <AboutTabPanel />

      {showBenchmarkingTab && (
        <BenchmarkingTabPanel
          benchmarkingTabLoading={!initialLoad}
          competitorAnalysisData={competitorAnalysisData}
          detailedComparisonData={detailedComparisonData}
        />
      )}
    </>
  )
}

export default TabPanels
